// Exports
export default {
	"MicrophoneButton": "MicrophoneButton_XysKF",
	"BadgeError": "BadgeError_1dtsj"
};
